import Code from 'eflex/models/code';

export default class FaultCode extends Code {}
